import React, { createContext, useContext, useEffect, useState } from 'react';

type DensityCtx = {
  compact: boolean;
  toggleCompact: () => void;
};

const DensityContext = createContext<DensityCtx>({ compact: false, toggleCompact: () => {} });

export function DensityProvider({ children }: { children: React.ReactNode }) {
  const [compact, setCompact] = useState<boolean>(() => localStorage.getItem('compact') === 'true');

  useEffect(() => {
    const root = document.documentElement;
    if (compact) root.classList.add('compact');
    else root.classList.remove('compact');
    localStorage.setItem('compact', String(compact));
  }, [compact]);

  const toggleCompact = () => setCompact(c => !c);

  return (
    <DensityContext.Provider value={{ compact, toggleCompact }}>
      {children}
    </DensityContext.Provider>
  );
}

export const useDensity = () => useContext(DensityContext);
